import { render, staticRenderFns } from "./location.vue?vue&type=template&id=5b46dbf2&scoped=true&"
import script from "./location.vue?vue&type=script&lang=js&"
export * from "./location.vue?vue&type=script&lang=js&"
import style0 from "./location.vue?vue&type=style&index=0&id=5b46dbf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46dbf2",
  null
  
)

component.options.__file = "location.vue"
export default component.exports